import { Component, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
    selector: 'demo-select',
    templateUrl: './demo-select.html',
    styleUrls: ['./demo-common.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoSelectComponent implements OnInit {
    form!: FormGroup;
    standaloneValue: string | null = null;
    isDisabled = false;

    countries = [
        { value: 'es', label: 'Spain' },
        { value: 'fr', label: 'France' },
        { value: 'de', label: 'Germany' },
        { value: 'it', label: 'Italy' },
        { value: 'pt', label: 'Portugal' },
    ];

    categories = [
        { value: 'food', label: 'Food & Drinks', items: ['Pizza', 'Pasta', 'Salad', 'Juice'] },
        { value: 'tech', label: 'Technology', items: ['Laptop', 'Phone', 'Tablet', 'Watch'] },
    ];

    constructor(private change: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.form = new FormGroup({
            country: new FormControl('es'),
        });
    }

    toggleDisabled() {
        this.isDisabled = !this.isDisabled;
        const country = this.form?.get('country');
        if (country) {
            if (this.isDisabled) {
                country.disable({ emitEvent: false });
            } else {
                country.enable({ emitEvent: false });
            }
        }
        this.change.markForCheck();
    }

    onStandaloneChanged(value: any) {
        this.standaloneValue = value;
        this.change.markForCheck();
    }
}
